import { Controller } from "stimulus"
import AdvancedController from "./advanced-controller"

export default class DropdownController extends AdvancedController {

  static targets = ["toggleable", "button"]

  toggle() {
    this.buttonTarget.classList.toggle('dropdown-toggle-active')
    this.toggleableTarget.classList.toggle('hidden')
  }
}